module.exports = "<input type=\"text\" id=\"location\" class=\"form-control\" placeholder=\"Enter address\" autocorrect=\"off\"\n       autocapitalize=\"off\" spellcheck=\"off\" type=\"text\" class=\"form-control\" #autocomplete>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/info-panel/place/place.component.html
// module id = ./client/app/components/info-panel/place/place.component.html
// module chunks = main